import { createRouter, createWebHistory } from 'vue-router'
import { unifiedRoutes } from './unified-routes'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory('/'),
  routes: unifiedRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// Dynamically register MoceroUI Inventory routes to avoid OOM during build
// (the inventory router has 100+ static component imports)
import('../../../MoceroUI/src/modules/Inventory/router/index').then(({ inventryrouter }) => {
  inventryrouter.forEach((route: any) => {
    router.addRoute({
      ...route,
      meta: { requiresAuth: true, moduleType: 'moceroui', ...route.meta }
    })
  })
})

// Authentication guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta?.requiresAuth)

  // Check for logout parameters from MoceroUI - allow access to login page
  const urlParams = new URLSearchParams(window.location.search)
  const logout = urlParams.get('logout')
  const source = urlParams.get('source')
  const isLogoutFromMoceroUI = logout === 'true' && source === 'MoceroUI'

  // Check authentication for protected routes
  if (requiresAuth && !authStore.isAuthenticated) {
    next('/auth/login')
    return
  }

  // Redirect authenticated users away from login, EXCEPT when logging out from MoceroUI
  if (to.path === '/auth/login' && authStore.isAuthenticated && !isLogoutFromMoceroUI) {
    next('/dashboard')
    return
  }

  next()
})

export default router
